import React, { useState } from 'react'
import { Accordion, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { styled } from '@mui/system'
import Styles from './ChargingScheduleListItem.module.css'
import Colors from 'Theme/Colors'
import PropTypes from 'prop-types'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import { formatChargingSchedule } from '../../Utils/Format'
import { ChargingScheduleChart } from 'Components'
import { ChargingSchedulePeriodList } from 'Containers'

const AccordionContainer = styled(Accordion)(({ theme }) => ({
  boxShadow: '0px 0px 0px 0px',
  borderRadius: '5px !important',
  width: '100%',
}))

const AccordionSummaryStyled = styled(MuiAccordionSummary)(({ theme }) => ({
  borderRadius: '5px',
  '&:hover': {
    backgroundColor: Colors.ChargePointLogListItemHover,
  },
  '& .MuiAccordionSummary-content': {
    marginTop: '4px',
    marginBottom: '8px',
  },
}))

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '0px',
}))

const ChargingScheduleListItem = ({ day, maxCurrent, itemRef }) => {
  const [chargingPeriods, setChargingPeriods] = useState([])

  return (
    <div className={Styles.Container}>
      <AccordionContainer>
        <AccordionSummaryStyled expandIcon={<ExpandMoreIcon />}>
          <div className={Styles.ChargingScheduleChartContainer}>
            <ChargingScheduleChart
              day={day}
              chartHeight={50}
              seriesData={chargingPeriods}
              hideAxis={false}
            />
          </div>
        </AccordionSummaryStyled>
        <StyledAccordionDetails>
          <div className={Styles.ChargingSchedulePeriodListContainer}>
            <ChargingSchedulePeriodList
              onValueSelected={(chargingPeriods) => {
                const formattedChargingSchedule =
                  formatChargingSchedule(chargingPeriods)
                setChargingPeriods(formattedChargingSchedule)
              }}
              defaultMaxCurrentInput={maxCurrent}
              ref={itemRef}
            />
          </div>
        </StyledAccordionDetails>
      </AccordionContainer>
    </div>
  )
}

ChargingScheduleListItem.propTypes = {
  day: PropTypes.string,
  maxCurrent: PropTypes.number,
}

export default ChargingScheduleListItem
